/* istanbul ignore file */
export const KEYCODE_ARROW_UP = 38;
export const KEYCODE_ARROW_DOWN = 40;
export const KEYCODE_ENTER = 13;
export const KEYCODE_ESC = 27;
export const KEYCODE_SPACE = 32;
export const KEYCODE_HOME = 36;
export const KEYCODE_END = 35;
